import React from 'react';
import PropTypes from 'prop-types';
import './StepContent.css';

/**
 * StepContent Component
 * Container for stage-specific content with consistent layout and overflow handling
 */
const StepContent = ({ currentStep, children }) => {
  return (
    <div className="step-content-container" data-current-step={currentStep}>
      <div className="step-content">
        {children}
      </div>
    </div>
  );
};

StepContent.propTypes = {
  currentStep: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
};

export default StepContent;
